module.exports = __webpack_public_path__ + "images/bg_direction_nav.png";